/**
 * Figma "Star 1" — Brand/300 ambient glow.
 * Figma uses a 1800×1122 shape at calc(50% ± half + 116/82), #00000 @ 15% + blur(180px).
 * A literal blurred rectangle floods the viewport in browsers; this radial gradient
 * matches the same position and color with a soft falloff (white edges, yellow center).
 */
import { useLocation } from 'react-router-dom';

import { isConfigureRoute } from 'constant/configure-nav';

const STAR_GLOW_POSITION_DEFAULT = '50% 42vh';
const STAR_GLOW_POSITION_CONFIGURE = '50% 50vh';
const STAR_GLOW_SIZE = 'min(720px, 70vw) min(360px, 38vh)';

export function BrandAmbientGlow() {
  const { pathname } = useLocation();
  const starGlowPosition = isConfigureRoute(pathname)
    ? STAR_GLOW_POSITION_CONFIGURE
    : STAR_GLOW_POSITION_DEFAULT;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-[1] overflow-hidden"
    >
      <div
        className="absolute inset-0 dark:hidden"
        style={{
          background: `radial-gradient(
            ellipse ${STAR_GLOW_SIZE} at ${starGlowPosition},
            rgba(249, 255, 46, 0.18) 0%,
            rgba(249, 255, 46, 0.08) 38%,
            rgba(249, 255, 46, 0.02) 58%,
            transparent 72%
          )`,
        }}
      />
    </div>
  );
}

/** Figma dark-mode grid overlay on authenticated screens */
export function DarkModeGridOverlay() {
  return (
    <div
      aria-hidden="true"
      className="dark-mode-grid-overlay pointer-events-none absolute inset-0 z-[1] hidden dark:block"
    />
  );
}
